import { createAction, props } from '@ngrx/store';
import { Invitation } from '@fantaz/shared/data-access/models';

export const init = createAction('[Invitations Page] Init');

export const loadInvitationsSuccess = createAction(
  '[Invitations/API] Load Invitations Success',
  props<{ invites: Invitation[]; total: number }>(),
);

export const loadInvitationsFailure = createAction(
  '[Invitations/API] Load Invitations Failure',
  props<{ error: any }>(),
);
